export default "__VITE_ASSET__DWBDjttZ__"